<template>
  <a-card :bordered='false'>
    <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="" name='keyword' style='margin-bottom: 10px;'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="sn">退货单号</a-select-option>
            <a-select-option value="product_name">商品名称</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="退货人信息" name='from_keyword'>
        <a-input style="width: 270px" v-model:value="search.from_keyword" placeholder="请输入退货人/退货人手机号进行搜索" />
      </a-form-item>
      <a-form-item label="收货人信息" name='to_keyword'>
        <a-input style="width: 270px" v-model:value="search.to_keyword" placeholder="请输入收货人/收货人手机号进行搜索" />
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table class='m-t-20' :pagination='false' :loading='listLoading' bordered rowKey='refund_warehousing_sn' :columns='columns' :data-source='list'>
      <template v-slot:product_name="{ record }">
        <div v-if='record.product.length == 1' >
          <div v-for="(item,index) in record.product" :key='index'>
            <a-card-meta>
              <template #avatar>
                <img :src="info.picdomain+'/'+item.product_image" alt=""
                  style="width:50px;height: 50px;object-fit:cover">
              </template>
              <template #description>   {{!item.product_sku_name || item.product_sku_name=='0' ? '单规格':item.product_sku_name}} - {{item.product_name}}</template>
            </a-card-meta>
          </div>
        </div>
        <div class="s_flex_ali" v-else>
          <div  v-for="(item,index) in record.product" :key='index'>
            <img class="m-r-10" :src="info.picdomain+'/'+(item.product_image)" v-if='index == 0' alt="" style="width:50px;height:50px">
          </div>
          <p class="m-l-5 m-r-10">多商品</p>
          <a-button type="primary" size="small" @click='targetList=record.product;goodDetailVisible=true'>查看商品详情</a-button>
        </div>
      </template>
      <template v-slot:from="{record}">
        <p>{{record.from}}</p>
        {{record.from_mobile}}
      </template>
      <template v-slot:to="{record}">
        <p>{{record.to}}</p>
        {{record.to_mobile}}
      </template>
      <template #title_num>
        退货数量
        <a-tooltip placement='right'>
          <template #title>包装的最小单位数量</template>
          <InfoCircleOutlined />
        </a-tooltip>
      </template>
      <template v-slot:return_quantity="{record}">
          <p @click="codeDetailVisible=true;targetId=record.refund_warehousing_sn" style="color:#f04635;cursor: pointer;">{{record.return_quantity || '-'}}</p>
      </template>
      <template v-slot:action="{ record }">
        <a v-has:antiDocumentsBackDetail="()=>{targetId=record.refund_warehousing_sn;orderDetailVisible=true}"  href="javascript:;">查看详情</a>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
  <a-modal title='退货二维码明细' :keyboard="false" :maskClosable='false' v-model:visible="codeDetailVisible" destroyOnClose :footer='null' :width="1200" centered>
      <codeDetail  :id="targetId"/>
  </a-modal>
  <a-modal title='商品详情' :keyboard="false" :maskClosable='false' v-model:visible="goodDetailVisible" destroyOnClose :footer='null' :width="1200" centered>
    <goodDetail  :listdata="targetList"/>
  </a-modal>
  <a-modal title='渠道退货单详情' :keyboard="false" :maskClosable='false' v-model:visible="orderDetailVisible" destroyOnClose :footer='null' :width="800" centered>
    <backOrderDetails  :id="targetId" type='channel'/>
  </a-modal>
</template>
<script>
  import { InfoCircleOutlined } from "@ant-design/icons-vue";
  import { reactive, ref, toRefs, onMounted, inject } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import useTableSearch from "@/hooks/useTableSearch";
  import { getRefundOrderChannel,getWarehouseList } from "@/api/antiFleeing";
  import codeDetail from './components/codeDetail'
  import store from "@/store";
  import goodDetail from '../../components/goodDetails.vue'
  import backOrderDetails from '../../components/backOrderDetails.vue'
  const defSearch = {
    page: 1,
    limit: 10,
    keyword: "",
    key_type:'sn',
    refund_warehouse_id: "",
    start_time: "",
    end_time: "",
    from_keyword:"",
    to_keyword:""
  };
  export default {
    components: {InfoCircleOutlined,codeDetail,goodDetail,backOrderDetails},
    setup() {
      const state = reactive({
        info: store.state.user.info,
        time: [],
        warehouseList:[],
        codeDetailVisible:false,
        targetId:"",
        goodDetailVisible:false,
        orderDetailVisible:false
      });
      let columns = [
        {
          title: "退货单号",
          dataIndex: "refund_warehousing_sn",
          key: "refund_warehousing_sn",
        },
        {
          title: "商品信息",
          dataIndex: "product_name",
          key: "product_name",
          slots: { customRender: "product_name" },
          width:300
        },
        {
          title: "退货人",
          dataIndex: "to",
          key: "to",
          slots: { customRender: "to" }
        },
        {
          title: "收货人",
          dataIndex: "from",
          key: "from",
          slots: { customRender: "from" }
        },
        {
          dataIndex: "return_quantity",
          key: "return_quantity",
          slots: { title: 'title_num',customRender: "return_quantity" } 
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          key: "create_time",
        },
        // {
        //   title: "注备",
        //   dataIndex: "remark",
        //   key: "remark"
        // },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      // 获取仓库
      const getWarehouse = async () => {
        let res = await getWarehouseList().then(res => res.data).catch(error => error);
        if (iscode(res)) {
          state.warehouseList = res.data;
        } else {
          message.error(res.msg);
        }
      }
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
      };

      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        getWarehouse();
        tableHoosks.initData(getRefundOrderChannel, search.value);
      });
      return {
        ...toRefs(state),
        ...tableHoosks,
        columns,
        changTime
      };
    },
  };
</script>